<template>
    <footer>
        <div class="container">
            <div class="top">
                <div class="logo"><img src="/src/assets/images/logobotton.png" alt=""></div>
                <div class="info">
                    <button v-if="this.$auth.check(['user', 'user.wholesale']) && !subscribed" @click.prevent="subscribe" class="btn btn-primary">Подписатся на рассылку</button>
                    <button v-if="this.$auth.check(['user', 'user.wholesale']) && subscribed" @click.prevent="unsubscribe" class="btn btn-danger">Отписаться от рассылки</button>
                    <a href="tel:+77273844180" class="phone">+7(727)384-41-80</a>
                </div>
                <ul class="menu-list">
                    <li><a href="http://alfastar.kz/">Главная</a></li>
                    <li><a href="https://alfastar.kz/partners">Партнерам</a></li>
                    <li><a href="https://alfastar.kz/company">О Компании</a></li>
                    <li><a href="https://alfastar.kz/delivery">Доставка</a></li>
                    <li><a href="https://alfastar.kz/contacts">Контакты</a></li>
                    <li><a href="https://alfastar.kz/service">Сервис</a></li>
                    <li><a href="https://alfastar.kz/trust">Нам доверяют</a></li>
                    <li><a href="https://alfastar.kz/payment">Оплата</a></li>
                </ul>
            </div>
        </div>
        <div class="powered">
            <div class="container">
                <div class="cont">
                    <span>© 2014-{{ new Date().getFullYear() }}, AST Qazaqstan Все права защищены.</span>
                    <span>EMOTIONS - разработка сайта</span>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    const swal = require('sweetalert2');
    export default {
        name: "Footer",
        data() {
          return {
            subscribed: false
          }
        },
        mounted() {
          this.axios
            .get(this.axios.defaults.baseURL + 'check-sub')
            .then(response => {
              if(response.data.message == 'ok') {
                this.subscribed = true
              } else {
                this.subscribed = false
              }
            })
            .catch(error => {
                        console.log(error);
                      })
        },
        methods: {
            subscribe() {
              this.axios
                      .post(this.axios.defaults.baseURL + 'subscribe', this.item)
                      .then(response => {
                        if (response.data.message === 'success') {
                          swal.fire({
                            icon: 'success',
                            title: 'Вы успешно подписались',
                            showConfirmButton: true,
                          });
                          this.subscribed = true;
                        } else {
                          swal.fire({
                            icon: 'error',
                            title: response.data.errors,
                            showConfirmButton: true,
                          });
                        }
                      })
                      .catch(error => {
                        console.log(error);
                      })
            },
            unsubscribe() {
              this.axios
                      .post(this.axios.defaults.baseURL + 'unsubscribe', this.item)
                      .then(response => {
                        if (response.data.message === 'success') {
                          this.subscribed = false;
                        } else {
                          swal.fire({
                            icon: 'error',
                            title: response.data.errors,
                            showConfirmButton: true,
                          });
                        }
                      })
                      .catch(error => {
                        console.log(error);
                      })
            }
        }
    }
</script>

<!--<style scoped>-->

<!--</style>-->



// WEBPACK FOOTER //
// src/views/app/FooterComp.vue